export default "/images/start.svg"